import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import InvestorDetailScreen from './screens/InvestorDetailScreen';
import InvestorListScreen from './screens/InvestorListScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import EditAgencyScreen from 'features/ManageDealer/screens/EditAgencyScreen';

function ManageInvestor(props) {
  const { isInvestorInfo } = props;
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0 pb-4">
        <Routes>
          <Route path="" element={<InvestorListScreen />} />
          <Route
            path={"/add"}
            element={<EditAgencyScreen agencyRole="INVESTOR" />}
          />
          <Route path="/:agencyId" element={<InvestorDetailScreen isInvestorInfo={isInvestorInfo} />} />
          <Route
            path={"/:agencyId/edit"}
            element={<EditAgencyScreen agencyRole="INVESTOR" isEditUserAgency={true} />}
          />
          <Route path="/:agencyId/sale/:saleId" element={<AgencySaleDetailScreen />} />
          <Route path="/:agencyId/:saleId" element={<AgencySaleDetailScreen />} />
          <Route path="/investor-info/:agencyId" element={<InvestorDetailScreen />} />
          <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ManageInvestor;
